import { Context } from "../components/root/context";
import { useContext } from "react";

export const useUser = () => {
  const { user } = useContext(Context);
  return { user };
};
